import type {ReactElement} from 'react'
import {memo, cloneElement, Children, useCallback} from 'react'
import type {NavigateOptions} from 'react-router'
import {useNavigate} from 'react-router'

import {getIsSakuraUI} from '../../../selectors'
import {extractTo} from '../../../utils/routes'

import {shouldNavigate} from './RouterLinkWrapper.utils'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  children: ReactElement<any>
  options?: NavigateOptions
  scrollToTop?: boolean
  insideApp?: boolean
  toAdminPage?: boolean
}

function RouterLinkWrapper({
  children,
  options,
  scrollToTop = true,
  insideApp = true,
  toAdminPage = false,
}: Props) {
  const navigate = useNavigate()
  const isSakuraUI = useAppSelector(getIsSakuraUI)

  const onClick = useCallback(
    (event: Event & React.KeyboardEvent) => {
      const child = Children.only(children)

      if (child.props.onClick != null) {
        child.props.onClick(event)
      }

      if (
        !toAdminPage &&
        isSakuraUI &&
        insideApp &&
        child.props.href != null &&
        shouldNavigate(event)
      ) {
        event.preventDefault()
        navigate(extractTo(child.props.href), options)

        if (scrollToTop) {
          window.scrollTo(0, 0)
        }
      }
    },
    [children, toAdminPage, isSakuraUI, insideApp, navigate, options, scrollToTop],
  )

  return cloneElement(Children.only(children), {onClick})
}

export default memo(RouterLinkWrapper)
